import dayJs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
dayJs.extend(customParseFormat)
import * as Yup from 'yup'
import phone from 'phone'
import isValidEmail from 'Shared/functions/validateEmail'
import { getPostcodeCountryData } from 'Shared/lib/postcodes'
import { FIELD_CONFIGS } from './fieldConfig'

export const fieldMappings = {
  'addressLine1': 'address_1',
  'addressLine2': 'address_2', 
  'addressLine3': 'address_3',
  'addressLine4': 'address_4'
}

export const getEditableItems = (section) => {
  const editableItems = []
  section.columns.forEach(column => {
    column.forEach(row => {
      if (row.editKey && !editableItems.includes(row.editKey)) {
        editableItems.push(row.editKey)
      }
    })
  })
  return editableItems
}

export const getInitialValues = (editableItems, targetData) => {
  const { joined, dateOfBirth, country, postcode } = targetData || {}
  const initialValues = {}

  editableItems.forEach(editKey => {
    const fieldConfig = FIELD_CONFIGS[editKey] || []

    fieldConfig.forEach(config => {
      const fieldName = config.field

      if (fieldMappings[fieldName]) {
        initialValues[fieldName] = targetData?.[fieldMappings[fieldName]] || ''
      } else if (targetData?.hasOwnProperty(fieldName)) {
        initialValues[fieldName] = targetData[fieldName] || ''
      } else {
        switch (fieldName) {
          case 'joinDate':
            initialValues[fieldName] = joined ? dayJs(joined, 'DD/MM/YYYY').format('YYYY-MM-DD') : ''
            break
          case 'dateOfBirth':
            initialValues[fieldName] = dateOfBirth ? dayJs(dateOfBirth).format('YYYY-MM-DD') : ''
            break
          case 'postcodeData':
            initialValues[fieldName] = {
              postcode: postcode || '',
              country: country || 'GB'
            }
            break
          default:
            initialValues[fieldName] = ''
        }
      }
    })
  })

  return initialValues
}

export const getValidationSchema = (editableItems) => {
  const validationRules = {}

  editableItems.forEach(editKey => {
    const fieldConfig = FIELD_CONFIGS[editKey] || []
    
    fieldConfig.forEach(config => {
      if (config.validation === 'email') {
        validationRules[config.field] = Yup.string().test('valid-email', 'Please enter a valid email address', (value) => {
          return !value || isValidEmail(value)
        })
      } else if (config.validation === 'phone') {
        validationRules[config.field] = Yup.string().test('valid-phone', 'Please enter a valid phone number', (value) => {
          if (!value) return true
          const country = window.ENV?.COUNTRY || 'GB'
          return phone(value, { country }).isValid || phone(value).isValid
        })
      } else if (config.validation === 'postcode') {
        validationRules[config.field] = Yup.mixed().test(
          'is-valid-postcode',
          (value) => {
            try {
              const countryData = getPostcodeCountryData(value?.country)
              if (!countryData) return 'Please enter a valid postcode'
              return `Please enter a valid postcode (e.g. ${countryData?.Zip_Format})`
            } catch (e) {
              return 'Please enter a valid postcode'
            }
          },
          (value) => {
            if (!value) return true

            if (typeof value === 'string') {
              value = {
                country: window.ENV?.COUNTRY || 'GB',
                postcode: value
              }
            }

            if (!value || typeof value !== 'object' || !value.postcode || !value.country) {
              return !value?.postcode
            }

            const countryData = getPostcodeCountryData(value.country)
            if (!countryData) return false

            return RegExp(countryData.Regex).test(value.postcode)
          }
        )
      }
    })
  })

  return Yup.object(validationRules)
}
